export default {
  icon: {
    size: 'small'
  }
}
